import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetModules = () =>
    useQuery({
        queryKey: ["modules"],
        queryFn: async () => {
            const response = await api.get("/api/v1/modules");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });

export const useGetBusinessModules = (businessId: string) =>
    useQuery({
        queryKey: ["businesses", businessId, "modules"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/modules/businesses/${businessId}/modules`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
        enabled: !!businessId,
    });

export const useBusinessModuleCheck = (businessId: string | null, slug: string) =>
    useQuery({
        queryKey: ["businesses", businessId, "modules", "check", slug],
        queryFn: async () => {
            const response = await api.get(`/api/v1/modules/businesses/${businessId}/modules/check/${slug}`);
            return response.data.data as { hasAccess: boolean; source: "direct" | "inherited" | null; inheritedFrom?: { id: string; name: string } };
        },
        retry: false,
        staleTime: 1000 * 60 * 5,
        enabled: !!businessId && !!slug,
    });

export const useInstallModule = () =>
    useMutation({
        mutationFn: async ({ businessId, moduleSlug }: { businessId: string; moduleSlug: string }) => {
            const response = await api.post(`/api/v1/modules/businesses/${businessId}/modules`, { moduleSlug });
            return response.data.data;
        },
        onSuccess: (_, { businessId }) => {
            queryClient.refetchQueries({ queryKey: ["businesses", businessId, "modules"] });
            queryClient.refetchQueries({ queryKey: ["modules"] });
        },
    });

export const useUninstallModule = () =>
    useMutation({
        mutationFn: async ({ businessId, moduleSlug }: { businessId: string; moduleSlug: string }) => {
            const response = await api.delete(`/api/v1/modules/businesses/${businessId}/modules/${moduleSlug}`);
            return response.data.data;
        },
        onSuccess: (_, { businessId }) => {
            queryClient.refetchQueries({ queryKey: ["businesses", businessId, "modules"] });
            queryClient.refetchQueries({ queryKey: ["modules"] });
        },
    });
